<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="5">
            <el-input size="medium" placeholder="搜索关键字: 系统用户名称" v-model="username" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="searchUser()">搜索</el-button>
          </el-col>
          <el-col :span="13">
            <div>&nbsp;</div>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="success" @click="openDialog(true, null)"
              v-if="checkButtonPermission('system:manage:user:add')">新增系统用户</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border fixed style="width: 100%">
          <el-table-column prop="username" label="用户名" min-width="100"></el-table-column>
          <el-table-column prop="email" label="邮箱" min-width="100"></el-table-column>
          <el-table-column prop="mobile" label="手机号" min-width="100"></el-table-column>
          <el-table-column prop="deptName" label="所属部门" min-width="120" />
          <el-table-column prop="roleName" label="角色" min-width="120" />
          <el-table-column prop="createTimeStr" label="创建时间" min-width="130"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">正常</span>
              <span v-else-if="scope.row.status === 0">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openDialog(false, scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('system:manage:user:edit')">编辑
              </el-button>
              <el-button @click="deleteUser(scope.row.userId)" type="danger" size="mini"
                v-if="checkButtonPermission('system:manage:user:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 25, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="menudialogTitle + '系统用户'" :visible.sync="dialogVisible" :modal="false"
      :close-on-click-modal="false" @close="resetForm()">
      <el-form :model="userForm" label-width="120px" size="medium" style="padding: 0 10%;">
        <el-form-item label="系统用户名称" prop="username">
          <el-input v-model="userForm.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="userForm.password" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="userForm.mobile" clearable></el-input>
        </el-form-item>

        <el-form-item label="部门" prop="deptId">
          <el-select v-if="addFlag != 'edit'" placeholder="部门" v-model="editDialogDeptSelectVal" clearable size="medium"
            style="width: 100%">
            <el-option v-for="dept in editDialogDepts" :value="dept.deptId" :key="dept.deptId"
              :label="dept.deptName"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="角色" prop="deptId">
          <el-select v-if="addFlag != 'edit'" placeholder="角色" v-model="editDialogRoleSelect" clearable
            @change="editDialogRoleChange" size="medium" style="width: 100%">
            <el-option v-for="role in editDialogRoles" :value="role.roleId" :key="role.roleId"
              :label="role.roleName"></el-option>
          </el-select>
          <span v-else-if="addFlag == 'edit'" v-text="editDialogRoleSelect"></span>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('userForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "menuList",
  data() {
    return {
      username: '',
      tableData: [],
      userForm: {},
      currentPage: 1,
      pageSize: 10,
      totalPage: 100,
      total: 100000,
      addFlag: true,
      dialogVisible: false,
      dialogOperation: '',
      menudialogTitle: '编辑',
      editDialogRoles: [],
      editDialogRoleSelect: '',
      editDialogRoleSelectVal: '',
      editDialogDepts: [],
      editDialogDeptSelectVal: '',

    }
  },
  created() {
    this.searchUser();
  },
  mounted() {
  },
  methods: {

    searchUser() {
      let reqParam = {
        username: this.username,
        size: this.pageSize,
        currentPage: this.currentPage,

      };
      this.$http.post('/api/system/sysUser/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "0") {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(e => {

      })
    },
    editUser(row) {
      this.$http.post('/api/system/sysUser/update', row, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '编辑系统用户信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.searchUser();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    deleteUser(userId) {
      this.$confirm('此操作将永久该系统用户信息, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/system/sysUser/delete?sysUserId=' + userId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "0") {
            this.$message({
              message: '删除系统用户信息成功',
              type: 'success'
            });
            this.dialogVisible = false;
            this.searchUser();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addUser(reqParam) {
      this.$http.post('/api/system/sysUser/save', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let data = resp.data;
        if (data.code === "0") {
          this.$message({
            message: '新增系统用户信息成功',
            type: 'success'
          });
          this.dialogVisible = false;
          this.resetForm();
          this.searchUser();
        } else {
          this.$alert(data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })

    },
    editDialogRolesChange(val) {
      this.editDialogRoleSelectVal = val;
    },
    editDialogGetRole() {
      this.$http.post('/api/system/sysRole/all', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "0") {
          this.editDialogRoles = data.resultList;
        }
      }).catch(e => {

      })
    },
    editDialogDeptChange(val) {
      this.editDialogDeptSelectVal = val;
    },
    editDialogRoleChange(val) {
      this.editDialogRoleSelectVal = val;
    },
    submitForm(formName) {
      if ('add' == this.dialogOperation) {
        let reqAddParam = {
          deptId: this.editDialogDeptSelectVal,
          roleId: this.editDialogRoleSelect,
          username: this.userForm.username,
          email: this.userForm.email,
          mobile: this.userForm.mobile,
          password: this.userForm.password,

        };
        this.addUser(reqAddParam);
      } else if ('edit' == this.dialogOperation) {
        console.log('edit');
        let reqEditParam = {
          userId: this.userForm.userId,
          deptId: this.editDialogDeptSelectVal,
          roleId: this.editDialogRoleSelectVal,
          username: this.userForm.username,
          email: this.userForm.email,
          mobile: this.userForm.mobile,
          password: this.userForm.password,

        };
        this.editUser(reqEditParam);
      }
      else {
        console.log('error submit!!');
        return false;
      }

    },
    editDialogGetDept() {
      this.$http.post('/api/system/dept/tree', {}, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if (data.code === "0") {
          this.editDialogDepts = data.resultList;
        }
      }).catch(e => {

      })
    },
    openDialog(addFlag, row) {
      this.editDialogGetDept();
      this.editDialogGetRole();

      if (addFlag) {
        this.menudialogTitle = '新增';
        this.dialogOperation = 'add';

      }

      else {
        this.menudialogTitle = '编辑';
        let temp = {};
        Object.assign(temp, row);
        console.log(temp);
        this.userForm = temp;
        this.dialogOperation = 'edit';

        this.editDialogDeptSelectVal = temp.deptId;
        this.editDialogRoleSelect = temp.roleName;
        this.editDialogRoleSelectVal = temp.roleId;
      }
      this.dialogVisible = true;
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchUser();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchUser();
    },
    resetForm() {
      this.userForm = {};
      this.editDialogDeptSelectVal = '';
      this.editDialogRoleSelect = '';
      this.editDialogRoleSelectVal = '';
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/system/sysuserList.vue